/** Ringfenced AI evidence/report pipelines. Default remains legacy. */
export const AI_PIPELINE_LEGACY = 'legacy';
export const AI_PIPELINE_SCHEMA_V1 = 'schema_v1';
export const AI_PIPELINE_SCHEMA_V2 = 'schema_v2';

export const AI_PIPELINE_MODES = [
  AI_PIPELINE_LEGACY,
  AI_PIPELINE_SCHEMA_V1,
  AI_PIPELINE_SCHEMA_V2,
];

export const AI_PIPELINE_LABELS = {
  [AI_PIPELINE_LEGACY]: 'Legacy (current production)',
  [AI_PIPELINE_SCHEMA_V1]: 'Schema v1 (verification prompts, titles only)',
  [AI_PIPELINE_SCHEMA_V2]: 'Schema v2 (per-file read + schema — in progress)',
};

export const AI_PIPELINE_BLURBS = {
  [AI_PIPELINE_LEGACY]: 'Current production prompts and distill/draft behaviour.',
  [AI_PIPELINE_SCHEMA_V1]:
    'Verification-oriented prompts; titles-only honesty; accreditor notes when present. Does not open file bytes.',
  [AI_PIPELINE_SCHEMA_V2]:
    'Per-file evidence analysis into a shared schema (registration seed + uploads). Legacy and v1 stay available. See docs/ai-pipeline-v2-plan.md.',
};

/**
 * Normalise stored mode. Unknown values fall back to legacy (safe default).
 * Does not remap schema_v1 <-> schema_v2.
 */
export function normalizeAiPipelineMode(value) {
  const v = String(value || '').trim();
  if (v === AI_PIPELINE_SCHEMA_V2) return AI_PIPELINE_SCHEMA_V2;
  if (v === AI_PIPELINE_SCHEMA_V1) return AI_PIPELINE_SCHEMA_V1;
  return AI_PIPELINE_LEGACY;
}

export function isSchemaV1Pipeline(mode) {
  return normalizeAiPipelineMode(mode) === AI_PIPELINE_SCHEMA_V1;
}

export function isSchemaV2Pipeline(mode) {
  return normalizeAiPipelineMode(mode) === AI_PIPELINE_SCHEMA_V2;
}